import { axios, handleError } from '../../lib'
import toast from 'react-hot-toast'
import TYPES from '../types'

const altzonesData = (data) => ({
  type: TYPES.ALT_zone_DATA,
  data,
})

export const getAllzones = (filter) => async (dispatch) => {
  try {
    const { status, ...response } = await axios.get(
      `/admin/zones${filter ? `?filter=${filter}` : ''}`,
    )
   
      if (filter) {
        return response
      } else {
        dispatch(altzonesData(response))
        return response
      }
  } catch (error) {
    console.error('Error fetching zones:', error)
    handleError(error.response)
    return { data: { zones: [], pagination: {} } }
  }
}

export const getSpecificzone = async (id) => {
  try {
    const response = await axios.get(`/admin/zones/${id}`)
    return response
  } catch (error) {
    console.error('Error fetching zone:', error)
    handleError(error.response)
  }
}

export const altzoneData = ({ id, ...data }, action) => async (dispatch) => {
  try {
    let apiResponse
    switch (action) {
      case 'add':
        apiResponse = await axios.post('/admin/zones', data)
        break
      case 'update':
        apiResponse = await axios.put(`/admin/zones/${id}`, data)
        break
      case 'delete':
        apiResponse = await axios.delete(`/admin/zones/${id}`)
        break
      default:
        apiResponse = null
    }
    
    if (apiResponse) {
      await dispatch(getAllzones())
      toast.success(apiResponse.message || `Zone ${action === 'add' ? 'created' : action === 'update' ? 'updated' : 'deleted'} successfully`)
      return { success: true }
    }
  } catch (error) {
    console.error('Error managing zone:', error)
    handleError(error.response)
    return { success: false }
  }
}

export const altzoneStatus = (id) => async (dispatch) => {
  try {
    const { status, ...response } = await axios.put(`/admin/zones/${id}/toggle-status`)
    
    if (status === 200) {
      await dispatch(getAllzones())
      toast.success(response.message || 'Zone status updated successfully')
      return { success: true }
    }
  } catch (error) {
    console.error('Error toggling zone status:', error)
    handleError(error.response)
    return { success: false }
  }
}
